import PageTitle from "./include/PageTitle";
import {Link} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {get_ai_models} from "../Utils/Data";

const AiModelList = ({title}) => {
    const [ai_models, setAi_models] = useState([]);

    useEffect(() => {
        const fetchAi_Models = async () => {
            const data = await get_ai_models();
            if (data) {
                setAi_models(data);
            }
        };
        fetchAi_Models();
    }, []);

    return (
        <>
            <PageTitle title={title}/>

            <section className="testimonial-one testimonial-one--page">
                <div className="container">
                    <div className="row">
                        {/* Testimonial One Single Start */}
                        {ai_models.length > 0 ?
                            ai_models.map((object) => (
                                <div
                                    className="col-xl-3 col-lg-3 wow fadeInRight"
                                    data-wow-delay="100ms"
                                    style={{
                                        visibility: "visible",
                                        animationDelay: "100ms",
                                        animationName: "fadeInRight"
                                    }}
                                >

                                    <Link to={{
                                        pathname: `/ai-models-details`,
                                    }}
                                          state={{object}}>
                                        <div className="testimonial-one__single">
                                            <div className="testimonial-one__single-inner">
                                                <div className="testimonial-one__single-img">
                                                    <div className="inner">
                                                        <img src={object.thumbnail} alt=""/>
                                                    </div>
                                                    <div className="quotes">
                                                        <i className="icon-quote11"/>
                                                    </div>
                                                </div>
                                                <div className="testimonial-one__single-text">
                                                    <span>{object.name}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))
                            : <div className="text-danger mx-auto text-center">
                                <span className="fw-bolder">NO MODELS AVAILABLE</span>
                            </div>}

                        {/* Testimonial One Single End */}
                    </div>
                </div>
            </section>


        </>
    )
}

export default AiModelList